import { useNavigate } from "react-router-dom";
import Modal from "../../../components/portal/Modal";
import successIcon from "../../../assets/icons/successIcon.svg";
import GradientButton from "../../../components/UI/buttonUI/GradientButton";

const UpdateBulkUserSuccess = ({ viewDetails }) => {
  const navigate = useNavigate();
  return (
    <Modal modalWidth="view-dialog-content max-w-xl">
      <img src={successIcon} alt="messageIcon" className="mx-auto mb-1 w-9" />
      <p className="view-success-msg-d">Users Successfully Updated!</p>
      <div className="rounded-md 3xl border border-lg5 shadow-md mt-4 relative p-3">
        <table className="w-full mt-2">
          <tbody>
            <tr className="bg-lg6">
              <td className="p-2 border border-lg5 text-dark-blue font-figtreeMedium text-sm">
                Total User Updated : {viewDetails.length}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="md:mt-5 pt-3 text-center">
        <GradientButton
          btnText="Ok"
          width="28"
          onClick={() => navigate("/user/all")}
        />
      </div>
    </Modal>
  );
};

export default UpdateBulkUserSuccess;
